import comparableUtils from './comparable.utils';
import regexConst from '@/consts/regex.const.js';
import moment from 'moment';

const getIsNotSortableField = function (value) {
  const valueIsUndefined = value === undefined;
  const valueIsNull = value === null;
  const valueIsNaN = isNaN(value);
  const valueIsNotADate = !regexConst.DATE.test(value);

  return valueIsUndefined || valueIsNull || (valueIsNaN && valueIsNotADate);
};

const sortingFunctionGenerator = (frontendSortingCriteria, rootGetters) => {
  return (comparable1, comparable2) => {
    // todo refactor this function is a bit of a mess with a lot of patches
    // should be more like check sortability of both fields, check types, parse values, sort values
    let comp1Field = comparableUtils.getFieldValueFromComp(comparable1, frontendSortingCriteria.sortFld, rootGetters.langCode.toUpperCase());
    let comp2Field = comparableUtils.getFieldValueFromComp(comparable2, frontendSortingCriteria.sortFld, rootGetters.langCode.toUpperCase());

    // sort null // undefined values
    const isNotSortableComp1 = getIsNotSortableField(comp1Field);
    const isNotSortableComp2 = getIsNotSortableField(comp2Field);

    if (isNotSortableComp1 && isNotSortableComp2) {
      return 0;
    } else if (isNotSortableComp1) {
      return -1;
    } else if (isNotSortableComp2) {
      return 1;
    }

    // if it matches float regular expresion parse it as a float
    if (regexConst.FLOAT.test(comp1Field)) {
      comp1Field = parseFloat(comp1Field);
    } else if (regexConst.DATE.test(comp1Field)) {
      comp1Field = moment(comp1Field).format('YYYY/MM/DD');
    } else {
      // if it's not a float nor a date it's an integer
      comp1Field = parseInt(comp1Field);
    }

    // if it matches float regular expresion parse it as a float
    if (regexConst.FLOAT.test(comp2Field)) {
      comp2Field = parseFloat(comp2Field);
    } else if (regexConst.DATE.test(comp2Field)) {
      comp2Field = moment(comp2Field).format('YYYY/MM/DD');
    } else {
      // if it's not a float nor a date it's an integer
      comp2Field = parseInt(comp2Field);
    }

    // todo I don't understand why this code is necessary
    if (typeof comp1Field === 'string' && typeof comp2Field !== 'string') {
      comp2Field = `${comp2Field}`;
    } else if (typeof comp2Field === 'string' && typeof comp1Field !== 'string') {
      comp1Field = `${comp1Field}`;
    }

    if (comp1Field === comp2Field) {
      return breakOrderDraw(comparable1, comparable2);
    }

    return comp1Field > comp2Field ? 1 : -1;
  };
};

// n is 0 indexed
// if you give as params n = 0 and fields = default it will search OriginalSourceId in the comp if exists
const getNthRelevantFieldOrNextWithValue = (comp, n, fields) => {
  const foundFields = [];

  fields.forEach((value) => {
    if (comp[value]) {
      foundFields.push(comp[value]);
    }
  });

  let indexToBeAccessed = n;
  if (indexToBeAccessed > foundFields.length - 1) {
    indexToBeAccessed = foundFields.length - 1;
  }

  return foundFields[indexToBeAccessed];
};

const breakOrderDraw = (comp1, comp2) => {
  const orderBreakFields = ['OriginalSourceId', 'SourceId', 'id'];

  let result = 0;
  orderBreakFields.find((_, index) => {
    const fieldComp1 = getNthRelevantFieldOrNextWithValue(comp1, index, orderBreakFields);
    const fieldComp2 = getNthRelevantFieldOrNextWithValue(comp2, index, orderBreakFields);
    if (fieldComp1 > fieldComp2) {
      result = 1;
      return true;
    } else if (fieldComp2 > fieldComp1) {
      result = -1;
      return true;
    } else {
      return false;
    }
  });

  if (result === 0) {
    Console.error('Sorting order break was not successful, is the comp twice in the sort list?');
  }
  return result;
};

export default {
  sortingFunctionGenerator,
};
